import PropTypes from 'prop-types';
import React from 'react';
var Header = function Header(_ref) {
  var header = _ref.header;
  return /*#__PURE__*/React.createElement("div", {
    className: "expandable-container__header"
  }, /*#__PURE__*/React.createElement("h5", null, header));
};
Header.propTypes = {
  header: PropTypes.string.isRequired
};
export default Header;